import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RawImage from 'components/RawImage';
import { loadProviderByID } from 'redux/modules/tve';

const block = 'tve-provider';

const mapStateToProps = ({ shared, tve }) => ({
  hasTempPass: tve.hasTempPass,
  provider: tve.provider,
  selected: tve.selected,
  vertical: shared.vertical,
});

class Logo extends React.Component {
  static propTypes = {
    hasTempPass: PropTypes.bool.isRequired,
    provider: PropTypes.string,
    selected: PropTypes.shape({
      logo2xWhite: PropTypes.string,
    }),
    vertical: PropTypes.string.isRequired,
  };

  static contextTypes = {
    store: PropTypes.shape({}),
  };

  static defaultProps = {
    provider: null,
    selected: null,
  };

  componentDidMount() {
    this.loadProvider();
  }

  componentDidUpdate({ provider: prevProv }) {
    const { provider: nextProv } = this.props;
    if (!prevProv && nextProv) {
      this.loadProvider();
    }
  }

  loadProvider = () => {
    const { provider, vertical } = this.props;
    const { store } = this.context;
    if (provider) {
      store.dispatch(loadProviderByID(vertical, provider));
    }
  }

  render() {
    const { hasTempPass, provider, selected } = this.props;
    if (hasTempPass || !provider) {
      return null;
    }
    if (selected && typeof selected.logo2xWhite !== 'undefined') {
      return (
        <div className={`${block}`}>
          <RawImage src={selected.logo2xWhite} />
        </div>
      );
    }
    return provider;
  }
}

export default connect(mapStateToProps)(Logo);
